import * as tracking from '@otto-ec/tracking-bct'
import {Action} from '@otto-ec/tracking-bct';

function sendEventToTrackingServer(event: object) {
    const trackingEvent = createTrackingEvent(event);
    tracking.submitEvent(trackingEvent)
}

function trackOnNextPageImpression(event: object) {
    const trackingEvent = createTrackingEvent(event);
    tracking.trackOnNextPageImpression(trackingEvent)
}


function createTrackingEvent(event: object) {
    const trackingEvent = {} as any;
    for (const [key, value] of Object.entries(event)) {
        trackingEvent[key] = Array.isArray(value) ? value : [value];
    }
    return trackingEvent;
}

function sendEventWithActionToTrackingServer(event: object, action: Action) {
    const trackingEvent = createTrackingEvent(event);
    tracking.submitEvent(trackingEvent, action)
}

function addFeaturesPageImpressionToTrackingServer(event: any[]) {
    tracking.submitMerge({}, event)
}

function submitMoveToTrackingServer(event: object) {
    const trackingEvent = createTrackingEvent(event);
    tracking.submitMove(trackingEvent)
}

function submitMoveWithActionToTrackingServer(event: object, action: Action) {
    const trackingEvent = createTrackingEvent(event);
    tracking.submitMove(trackingEvent, action)
}

export {
    sendEventToTrackingServer,
    trackOnNextPageImpression,
    sendEventWithActionToTrackingServer,
    addFeaturesPageImpressionToTrackingServer,
    submitMoveToTrackingServer,
    submitMoveWithActionToTrackingServer
}
